import { getFirstWeekLoss } from "../helpers"

export default (getView) =>
  ({ nextStepPath, timeout } = {}) => ({
    ...getView({
      nextStepPath,
    }),

    init() {
      this.handleLoadingEnd = this.handleLoadingEnd.bind(this)
      this.commonInit()
    },

    getFirstWeekLoss() {
      return getFirstWeekLoss({
        values: this.store.values,
        isMetric: this.store.isMetric()
      })
    },

    isWeightGain() {
      const { weightKg, weightLbs, targetWeightKg, targetWeightLbs } = this.store.values
      const isMetric = this.store.isMetric()
  
      const currentWeight = isMetric ? weightKg : weightLbs
      const targetWeight = isMetric ? targetWeightKg : targetWeightLbs
  
      return targetWeight >= currentWeight
    },
    
    getFirstWeekDiff() {
      if (this.isWeightGain()) {
        const isMetric = this.store.isMetric()
        return isMetric ? 1 : 2
      } else {
        return this.getFirstWeekLoss()
      }
    },

    handleLoadingEnd() {
      setTimeout(() => {
        window.location = nextStepPath || this.pageState?.nextStepPath
      }, timeout || 2000)
    },
  })
